import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { apiURL } from '../../../../assets/data/api-url';
import { globalDatas } from '../../../../assets/data/globals';
import { ApiResponse } from '../../../core/enums/api-response.enum';
import { ModalType } from '../../../core/enums/modal-type.enum';
import { relationEnum } from '../../../core/enums/relation.enum';
import { EmailVerificationResponse } from '../../../core/models/email-verification-response.model';
import { CommonService } from '../../../core/services/common.service';
import { EncryptionService } from '../../../core/services/encryption.service';
import { MiddlewareService } from '../../../core/services/middleware.service';
import { ModalService } from '../../../core/services/modal.service';
import { CaptchaComponent } from '../../../shared/components/captcha/captcha.component';
import { EmailVerificationComponent } from '../../../shared/components/email-verification/email-verification.component';
import { ValidationMessageComponent } from '../../../shared/components/validation-message/validation-message.component';
import { NoArabicInputDirective } from '../../../shared/directives/no-arabic-input.directive';
import { NoWhitespaceDirective } from '../../../shared/directives/no-whitespace.directive';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    EmailVerificationComponent,
    TranslateModule,
    CaptchaComponent,
    NoArabicInputDirective,
    NoWhitespaceDirective,
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent {
  signInForm!: FormGroup;
  isSubmitted = false;
  componentName = 'signIn';
  showPassword = false;
  signInResponse: any;
  showCaptcha = false;
  showTempSuspendMessage: boolean = false;
  private formSubscription: Subscription | null = null;

  constructor(
    public router: Router,
    private _fb: FormBuilder,
    private _middlewareService: MiddlewareService,
    private encryptionService: EncryptionService,
    private commonService: CommonService,
    private modalService: ModalService,
    protected translateService: TranslateService
  ) {
    this.loadSignInForm();
  }

  ngOnInit(): void {
    localStorage.removeItem('accty');
    this.formSubscription = this.signInForm.valueChanges.subscribe((value) => {
      if (this.isSubmitted) {
        this.showCaptcha = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }

  onVerifyOTP(emittedData: EmailVerificationResponse) {
    if (this.commonService.isBrowser) {
      if (emittedData?.status) {
        localStorage.setItem(
          'xyzACCjsiiyu',
          this.commonService.generateRandomString(20)
        );
        localStorage.setItem('givenName', this.signInResponse?.data?.givenName);
        // Instana user tracking
        const ineum = (window as any).ineum;
        if (typeof ineum === 'function') {
          ineum('meta', 'touristUserEmail', this.signInResponse?.data?.email);
        }
        this.commonService.setAuthenticatedSignal(true);
        this.commonService.setLanguage(
          this.signInResponse?.data?.preferredLanguage
        );
        this.getSelfProfileDetails();
      }
    }
  }

  getSelfProfileDetails() {
    this.commonService.getSelfProfileDetails().subscribe((response) => {
      if (response?.code === ApiResponse.OK) {
        if (response?.result?.data) {
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
          this.router.url.includes('evisa-payment')
            ? this.router.navigate([
              this.commonService.getRouteStartIndex() +
              '/user/application/list',
            ])
            : this.router.navigate([
              this.commonService.getRouteStartIndex() + '/user/profile',
            ]);
        } else {
          this.modalService.commonAlertModal(
            'PROFILE.PROFILE_STATUS_INCOMPLETE_WARNING_MESSAGE',
            ModalType.WARNING
          );
          // setTimeout(() => {
          //   window.location.reload();
          // }, 5000);
          this.router.navigate(
            [
              this.commonService.getRouteStartIndex() +
              '/user/profile/add-details',
            ],
            { state: { relation: relationEnum.SELF } }
          );
        }
      }
    });
  }

  loadSignInForm() {
    this.signInForm = this._fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(globalDatas.EMAIL_REG_EXP),
        ],
      ],
      password: ['', [Validators.required]],
    });
    this.signInForm.valueChanges.subscribe(() => {
      if (this.showTempSuspendMessage) {
        this.showTempSuspendMessage = false;
      }
    });
  }

  onClickSignIn() {
    this.isSubmitted = true;
    if (this.signInForm.valid) {
      this.showCaptcha = true;
      // this.onSubmit();
    }
  }

  async onSubmit() {
    if (this.signInForm.valid) {
      const encryptedPayload = await this.encryptionService.encryptData(
        this.signInForm.value
      );
      if (this.commonService.isBrowser) {
        this._middlewareService
          .callPostMiddleware(`${apiURL.signIn}`, { payload: encryptedPayload })
          .subscribe((response: any) => {
            if (response?.code === ApiResponse.OK) {
              this.showCaptcha = false;
              this.signInResponse = response?.result;
            } else if (response?.code === ApiResponse.ERROR) {
              this.showTempSuspendMessage = true;
            } else {
              this.showCaptcha = false;
            }
          });
      }
    }
  }

  handleRecaptchaResponse(response: boolean) {
    if (response) {
      this.onSubmit();
    }
  }

  navigate(url: string) {
    this.router.navigateByUrl(this.commonService.getRouteStartIndex() + url);
  }
}
